module.exports = __webpack_public_path__ + "img/307.68b2ef94.jpg";